// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-f689a9cc] .el-dialog {\n  width: 1000px !important;\n}\n[data-v-f689a9cc] .el-dialog .el-dialog__body {\n  padding: 10px 10px;\n  min-height: 520px;\n  overflow: auto;\n}\n.el-form-item--mini.el-form-item[data-v-f689a9cc] {\n  margin-bottom: 10px;\n}", ""]);
// Exports
module.exports = exports;
